import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorIsPendingWalletCard = (card: cardApiSpec.Card): boolean =>
  card.status === "PendingActivation" || card.status === "PendingFulfillment";
